import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {Group, GroupApiResponse} from "features/model/types/groups/groupsSchema";


interface GroupState {
    groups: Group[];
    currentPage: number;
    pageSize: number;
    totalItems: number;
    isLoading: boolean;
    status: number;
}

const groupsSlice = createSlice({
    name: "groups",
    initialState: {
        groups: [],
        currentPage: 0,
        pageSize: 10,
        totalItems: 0,
        isLoading: true,
        status:200,
    } as GroupState,
    reducers: {
        setGroups: (state, action: PayloadAction<GroupApiResponse>) => {
            const { data  } = action.payload;
            state.groups = data.items;
            state.totalItems = data.pagination.pageCount * state.pageSize;
            state.isLoading = false;
        },
        setGroupsCurrentPage: (state, action: PayloadAction<number>) => {
            state.currentPage = action.payload;
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        setGroupsError: (state, action: PayloadAction<number>) => {
            state.isLoading = false;
            state.status = action.payload
        },
    },
});

export const { setGroups,setGroupsError, setLoading,setGroupsCurrentPage } = groupsSlice.actions;
export const groupsReducer = groupsSlice.reducer;
